import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { registerSW } from "virtual:pwa-register";
import { App } from "./App.js";
import { startErrorReporting } from "./error-reporting.js";
import { needRefresh, setUpdate } from "./pwa-state.js";
import "./styles/app.css";

const root = document.getElementById("root");
if (!root) throw new Error("Chybí element #root");

// Předrenderovaný obsah (/cs/, /en/) se nahradí stejným vykreslením v prohlížeči (DEC-001).
createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);

// Service worker (NFR-003): nová verze se projeví mimo rozpracovaný test (pwa-state.ts).
setUpdate(registerSW({ immediate: true, onNeedRefresh: needRefresh }));

// Chyby do GlitchTipu až po prvním vykreslení (DEC-005).
startErrorReporting();
